const key = "allow-business-management";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]+\/security$/);
};

const modify = (resp) => {
	if(resp.data.Success !== true || !resp.data.Data) {
		return;
	}
	
	const assigned = resp.data.Data.Assigned;
	const role = resp.data.Data.Roles.find(r => r.Code === assigned[0].Code);

	const allowReadBusiness = { Effect: "Allow", Path: "/types/DEALER/business/*/read" };
	role.Actions.push(allowReadBusiness);

};

export const allowBusinessManagement = [key, applicable, modify];